import {webConstants} from "../../webConstants";
import {useUserStats} from "../../contexts/UserStatsContext";
import {logout} from "../../services/authService";
import {useNavigate, useLocation, Link} from "react-router-dom";

export function AdminHeader() {
    const {profile} = useUserStats();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        logout();
        navigate("/login", { replace: true });
    };

    const username = profile?.login || "Username";

    return (
        <header className="sticky top-0 z-50 w-full glass-panel border-b-0 border-b-white/5">
            <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
                <div className="flex items-center gap-8">
                    <Link to="/dashboard" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
                        <div
                            className="flex items-center justify-center w-8 h-8 rounded-lg bg-gradient-to-br from-primary to-blue-700 text-white shadow-lg shadow-primary/20">
                            <span className="material-symbols-outlined text-xl">token</span>
                        </div>
                        <h1 className="font-bold text-lg tracking-tight uppercase">{webConstants.projectName}</h1>
                    </Link>
                    <nav className="hidden md:flex items-center gap-1">
                        <Link
                            to="/dashboard"
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                                location.pathname === "/dashboard"
                                    ? "text-white bg-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.05)]"
                                    : "text-white/60 hover:text-white hover:bg-white/5"
                            }`}>
                            Dashboard
                        </Link>
                        {profile?.pool_enabled && (
                            <Link
                                to="/pool"
                                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                                    location.pathname === "/pool"
                                        ? "text-white bg-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.05)]"
                                        : "text-white/60 hover:text-white hover:bg-white/5"
                                }`}>
                                Pool
                            </Link>
                        )}
                        <Link
                            to="/proxy"
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                                location.pathname === "/proxy"
                                    ? "text-white bg-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.05)]"
                                    : "text-white/60 hover:text-white hover:bg-white/5"
                            }`}>
                            Blockchain Proxy
                        </Link>
                        <Link
                            to="/builds"
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                                location.pathname === "/builds"
                                    ? "text-white bg-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.05)]"
                                    : "text-white/60 hover:text-white hover:bg-white/5"
                            }`}>
                            Builds
                        </Link>
                        <Link
                            to="/settings"
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                                location.pathname === "/settings"
                                    ? "text-white bg-white/10 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.05)]"
                                    : "text-white/60 hover:text-white hover:bg-white/5"
                            }`}>
                            Settings
                        </Link>
                    </nav>
                </div>
                <div className="flex items-center gap-4">
                    <div className="relative group">
                        <button
                            className="flex items-center gap-3 px-3 py-1.5 rounded-full bg-white/5 hover:bg-white/10 border border-white/5 hover:border-white/10 transition-all cursor-pointer">
                            <span className="material-symbols-outlined text-white/80 text-lg">person</span>
                            <span
                                className="text-sm font-medium text-white hidden sm:block">{username}</span>
                            <span
                                className="material-symbols-outlined text-white/50 group-hover:text-white transition-colors text-lg">expand_more</span>
                        </button>
                        <div
                            className="absolute right-0 top-full mt-2 w-48 rounded-xl glass-panel border border-white/10 overflow-hidden opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all transform origin-top-right z-50 shadow-2xl translate-y-2 group-hover:translate-y-0">
                            <div className="p-1">
                                <button
                                    onClick={handleLogout}
                                    className="w-full text-left px-4 py-2.5 rounded-lg text-sm text-rose-400 hover:bg-rose-500/10 hover:text-rose-300 transition-colors flex items-center gap-2">
                                    <span className="material-symbols-outlined text-lg">logout</span>
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

